import { render, staticRenderFns } from "./distcommissiontype-add-or-update.vue?vue&type=template&id=2525f9d4&"
import script from "./distcommissiontype-add-or-update.vue?vue&type=script&lang=js&"
export * from "./distcommissiontype-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports